import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { LogoMark } from "@/components/Logo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;
        const sessionId = new URLSearchParams(location.hash.slice(1)).get("session_id");
        (async () => {
            try {
                const res = await axios.post(
                    `${API}/auth/session`,
                    { session_id: sessionId },
                    { withCredentials: true }
                );
                navigate("/admin", { state: { user: res.data }, replace: true });
            } catch {
                navigate("/admin", { replace: true });
            }
        })();
    }, [location, navigate]);

    return (
        <div
            data-testid="auth-callback-loading"
            className="flex min-h-screen flex-col items-center justify-center gap-6 bg-[#1C1917] text-stone-100"
        >
            <LogoMark className="h-14 w-auto animate-pulse" />
            <p className="font-mono-alt text-xs uppercase tracking-[0.3em] text-stone-400">
                Accesso in corso…
            </p>
        </div>
    );
}
